var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.withHours)?[_vm._v(_vm._s(_vm.hours)+":")]:_vm._e(),_vm._v(_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }